import React, { useState } from 'react';
import {functions} from 'constants/index';
import {useStyles} from './style';
import ApiServices from 'services/ApiServices';
import Form from 'components/Form/FormTwoColumns';
import ComponentContainer from 'components/Container'
import { Typography } from '@material-ui/core';
import {showMessagePersonalizedPosition, showMessagePersonalizedToast} from 'services/SweetAlert'
import LoadingSpinner from 'components/LoadingSpinner';
import DialogLoadingMessage from 'components/LoadingMessage/index'
import MostrarConstancia from '../MostrarConstancia'
export default function Formulario(props) {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [elements, setElements] = useState({
        password: { 
            idelement: "password",  value:'', label: "Ingrese Contraseña *", finalRequiredLength: 50,
            pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,50}$", 
            validators: ['required'], errorMessages:['Campo requerido'], isError:false, elementType:'password' 
        },
    });
    const [openModal, setOpenModal] = useState({open: false, base64: ''});
    const [mensaje, setMensaje] = useState({loading: false, title:''});

    const MostrarConstanciaGenerada = async () =>{     
        setMensaje({loading: true, title: 'Obteniendo constancia ...'})   
        try {
            var datos = {document: "constancia", id: props.saveDataDescargarConstancia?.idSolicitud}
            const response  = await ApiServices.solicitudesDeEmpadronamiento.openFile(datos)
            if(response.error!==null){
                showMessagePersonalizedPosition('error','¡Advertencia!', response.error.message,'center')
            }else{
                if(response.data?.base64 === '' || response.data?.base64 === null || response.data?.base64 === undefined){
                    showMessagePersonalizedPosition('success','¡Advertencia!', 'base64 viene vacio, favor de intentar de nuevo','center')
                }else{
                    setOpenModal({open: true, base64: response.data?.base64})
                    showMessagePersonalizedPosition('success','¡BIEN!', response.data.message,'center')
                }
            }                   
        } catch (exception) {
            showMessagePersonalizedPosition('success','¡Advertencia!', 'Intente de nuevo','center')
        }
        setMensaje({loading: false, title: ''})
    }
    const CerrarMostrarConstancia = () =>{
        setOpenModal({open: false, base64: ''})
    }
    const DescargarConstanciaDeEmergencia = async () => {
        setLoading(true)
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement(
            elements,
            setElements
        );        
        if(allGood){        
            props.saveDataDescargarConstancia.password = elements.password.value
            try {
                const response  = await ApiServices.constanciaEmpadronamiento.generarActualizacionInscripcion(props.saveDataDescargarConstancia)
                if(response.error!==null){
                    showMessagePersonalizedPosition('error','Oopss!', response.error.message,'center')
                }else{
                    elements.password.value=''
                    props.handleClose()
                    MostrarConstanciaGenerada()
                    showMessagePersonalizedPosition('success','¡BIEN!', response.data.message,'center')
                }                   
            } catch (exception) {
                if (exception.status===404) {
                    showMessagePersonalizedToast('error', '¡Oops! ' +"Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }
                else {
                    showMessagePersonalizedToast('error', '¡Oops! ' +"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.")
                }                
            }
        }
        setLoading(false)
    }

    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={mensaje.loading} title={mensaje.title}/>
            <LoadingSpinner open={loading} message={'Generando constancia, espere por favor....'} />
            <ComponentContainer>
                <Typography className={classes.description} >
                    Este proceso solo puede ser utilizado, por el empadronador, cuando la constancia no ha sido generada o el archivo esta dañado.
                </Typography>
                <Typography className={classes.description} >
                    Cuando se genere la constancia, deberá darle clic en el botón "DESCARGAR CONSTANCIA EMPADRONAMIENTO" de dicho registro en la tabla
                </Typography>
                <Typography className={classes.description} >
                    Ingrese su contraseña de Firma Electrónica para generar la constancia.
                </Typography>
                <Form   
                    elements= {elements} 
                    BotonCancelar={props.handleClose}
                    BotonGenerarPDF={DescargarConstanciaDeEmergencia}
                />
                {
                    (openModal.open) && (
                        <MostrarConstancia
                            open={openModal.open}
                            base64={openModal.base64}
                            handleClose={CerrarMostrarConstancia}
                        />
                    )
                }
            </ComponentContainer>
        </div>
    );
}